module.exports = __webpack_public_path__ + "static/Curtis.58a75b1b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team/Curtis.jpg
// module id = 1293
// module chunks = 137408898365125